import React, { useEffect, useLayoutEffect } from "react";

import useChat from "../hooks/useChat";
import { postMessageToParent } from "../utils";
import { Box } from "@mui/material";
import { IChatContextV2 } from "../types/ChatInterfaces";

const withV2ChatMessageListener = (
  WrappedComponent: React.ComponentType<any>
) => {
  return (props: React.ComponentProps<typeof WrappedComponent>) => {
    const {
      themeConfig,
      config,
      setThemeConfig,
      setConfig,
      handleConfigTheme,
    } = props;
    const {
      showChat,
      activeView,
      hideChat,
      sendData,

      setSchedulerMsg,
      handleFormSubmit,
      // handleInterviewSchedule,
      convId,
      messages,
      modalConfig,
      schedulerMsg,

      handleInitialize,
      handleParentWebsiteEvent,
      fetchLatestChat,
      handleInterviewScheduleMsgId,
      handleUpdateMessage,
      reinitializeChat,
    } = useChat() as IChatContextV2; // Ensure useChat returns IChatContextV2

    useEffect(() => {
      const handleIframeApi = async ({ data }: { data: any }) => {
        switch (data.action) {
          case "sendPayload":
            return sendData(data.payload);
          case "event":
            const { type, text, conversationId } = data.payload;
            if (type === "botInitialize") {
              const botData = data.payload.payload?.data || {};
              const parentUrl = data.payload.payload?.url || "";

              handleConfigTheme({
                config: botData?.config,
                themeConfig: botData?.themeConfig,
                styleConfigs: botData?.styleConfigs,
              });

              handleInitialize({
                ...botData,
                config: { ...botData?.config, ...config },
                parentUrl,
              });
            }
            if (type === "parentWebsiteEvent") {
              handleParentWebsiteEvent(data.payload?.payload);
            } else if (type === "updateMessage") {
              handleUpdateMessage(data.payload?.payload);
            } else if (type === "reInitialise") {
              reinitializeChat();
            } else if (type === "show") {
              showChat();
            } else if (type === "hide") {
              hideChat();
            } else if (type === "toggle") {
              activeView !== "side" ? showChat() : hideChat();
            } else if (type === "GEO_LOCATION") {
              // Dispatch location event to interested components
              window.dispatchEvent(
                new CustomEvent("geoLocationReceived", {
                  detail: data.payload.payload,
                })
              );
            } else if (type === "updateConfig") {
              // to update or append to config
              setConfig((prev: any) => ({
                ...prev,
                ...data?.payload?.payload,
              }));
            } else {
              sendData({ type, payload: data.payload });
            }
            break;
          case "hireexp":
            if (["style"].includes(data?.payload?.type)) {
              setSchedulerMsg((prev) => ({
                ...prev,
                [data?.payload?.type]: data.payload.value,
              }));
            } else if (["scheduleConfirmation"].includes(data?.payload?.type)) {
              handleInterviewScheduleMsgId(data?.payload?.value);
            }

          case "form":
            if (
              ["formSubmit", "formSubmitError"].includes(data?.payload?.type)
            ) {
              handleFormSubmit(
                data?.payload?.value?.data || {},
                data.payload.type
              );
            }
          default:
            break;
        }
      };

      window.addEventListener("message", handleIframeApi);
      return () => {
        window.removeEventListener("message", handleIframeApi);
      };
      // eslint-disable-next-line
    }, [
      convId,
      // add initial payload parent event here
      messages.length,
      modalConfig.type,
      schedulerMsg?.data,
      schedulerMsg?.style,
      activeView,
      themeConfig,
      config,
    ]);

    useEffect(() => {
      const handleVisibilityChange = () => {
        if (document.visibilityState === "visible") {
          fetchLatestChat(); // Call the function to fetch the latest chat
        }
      };

      document.addEventListener("visibilitychange", handleVisibilityChange);

      return () => {
        document.removeEventListener(
          "visibilitychange",
          handleVisibilityChange
        );
      };
    }, [fetchLatestChat]);
    // Pass down all props, including custom props
    return <>{themeConfig ? <WrappedComponent {...props} /> : null}</>;
  };
};

export default withV2ChatMessageListener;
